module.exports = __webpack_public_path__ + "static/img/li4_5.de3786e4.png";